import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import { useEffect, useState } from "react";
import {
  allPerformance,
  allServiceUsed,
} from "../../../../../../../features/admin/common/Slice";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  Create,
  GetAll,
} from "../../../../../../../../src/features/admin/quality_management/resource_requirement/externaldetails/Slice";

function Externally_Service_Form({ handleClose }) {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm();

  const all_performance = useSelector((state) => state.common.all_performance);
  const all_service_used = useSelector(
    (state) => state.common.all_service_used,
  );

  useEffect(() => {
    dispatch(allServiceUsed());
    dispatch(allPerformance());
  }, [dispatch]);

  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(Create(data));

      if (res.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        reset();
        setSuccess(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          <div className="row">
            {/* Name Of Vendor */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Name Of Vendor</Form.Label>
                <Form.Control
                  placeholder="Name Of Vendor"
                  {...register("name", {
                    required: "Vendor name is required",
                  })}
                />
                {errors.name && (
                  <Form.Text className="text-danger">
                    {errors.name.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Address */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  placeholder="Address"
                  {...register("address", {
                    required: "Address is required",
                  })}
                />
                {errors.address && (
                  <Form.Text className="text-danger">
                    {errors.address.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Contact Person */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Contact Person</Form.Label>
                <Form.Control
                  placeholder="Contact Person"
                  {...register("contact_person_name", {
                    required: "Contact person is required",
                  })}
                />
                {errors.contact_person_name && (
                  <Form.Text className="text-danger">
                    {errors.contact_person_name.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Email */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  placeholder="Email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "a valid email",
                    },
                  })}
                />
                {errors.email && (
                  <Form.Text className="text-danger">
                    {errors.email.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Mobile No */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Mobile No</Form.Label>
                <Form.Control
                  placeholder="Mobile No"
                  {...register("contact_no", {
                    required: "Mobile number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "valid 10 digit mobile number",
                    },
                  })}
                />
                {errors.contact_no && (
                  <Form.Text className="text-danger">
                    {errors.contact_no.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Service Used */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Service Used</Form.Label>
                <Controller
                  name="service_used_id"
                  control={control}
                  rules={{ required: "Service is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_service_used}
                      value={
                        all_service_used?.find(
                          (o) => o.value === field.value,
                        ) || null
                      }
                      onChange={(e) => field.onChange(e?.value || null)}
                    />
                  )}
                />
                {errors.service_used_id && (
                  <Form.Text className="text-danger">
                    {errors.service_used_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Performance */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Performance</Form.Label>
                <Controller
                  name="performance_id"
                  control={control}
                  rules={{ required: "Performance is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_performance}
                      value={
                        all_performance?.find((o) => o.value === field.value) ||
                        null
                      }
                      onChange={(e) => field.onChange(e?.value || null)}
                    />
                  )}
                />
                {errors.performance_id && (
                  <Form.Text className="text-danger">
                    {errors.performance_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Remark */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Remark</Form.Label>
                <Form.Control
                  placeholder="Remark"
                  {...register("remark", {
                    required: "Remark is required",
                  })}
                />
                {errors.remark && (
                  <Form.Text className="text-danger">
                    {errors.remark.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          </div>

          {/* Buttons */}
          <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Reset
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  // onClick={handleSubmit(() => setSuccess(true))}
                  onClick={handleSubmit(onSubmit)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Externally_Service_Form;
